import { Toast as SharedToast, ToastButton as SharedToastButton } from '@stamhoofd/frontend-notifications/Toast';
import type { ToastListener as SharedToastListener } from '@stamhoofd/frontend-notifications/Toast';

/** @deprecated Import Toast from @stamhoofd/frontend-notifications/Toast instead. */
export const Toast = SharedToast;
/** @deprecated Import Toast from @stamhoofd/frontend-notifications/Toast instead. */
export type Toast = SharedToast;

/** @deprecated Import ToastButton from @stamhoofd/frontend-notifications/Toast instead. */
export const ToastButton = SharedToastButton;
/** @deprecated Import ToastButton from @stamhoofd/frontend-notifications/Toast instead. */
export type ToastButton = SharedToastButton;

/** @deprecated Import ToastListener from @stamhoofd/frontend-notifications/Toast instead. */
export type ToastListener = SharedToastListener;
